import { Component, Input, OnInit } from '@angular/core';
import { TraceClassDecorator } from '@sentry/angular';

enum Operations {
    ZOOMIN = 'ZOOMIN',
    ZOOMOUT = 'ZOOMOUT',
    ROTATELEFT = 'ROTATELEFT',
    ROTATERIGHT = 'ROTATERIGHT'
}

export class OperationsValues {
    readonly MAXZOOM: number = 2.5;
    readonly MINZOOM: number = 0.5;
    readonly MAXROTATE: number = 180;
    readonly MINROTATE: number = -180;
}

@Component({
    selector: 'app-image-enlarger',
    templateUrl: './image-enlarger.component.html',
    styleUrls: ['./image-enlarger.component.css']
})
@TraceClassDecorator()
export class ImageEnlargerComponent implements OnInit {
    @Input('type')
    type: string = '';

    @Input('src')
    src: string = '';

    @Input('width')
    width: string = '';

    @Input('height')
    height: string = '';

    @Input('overlay_class_name')
    overlay_class_name: string = '';

    @Input('class_name')
    class_name: string = '';

    @Input('alt_name')
    alt_name: string = '';

    @Input('link_name')
    link_name: string = '';

    @Input('link_class')
    link_class: string = '';

    @Input('link_icon')
    link_icon: string = '';

    open: boolean = false;
    image_element: HTMLElement | null = null;
    zoom_scale: number = 1.0;
    rotation: number = 0;
    Operations_Label = Operations;
    operation_Values: OperationsValues = new OperationsValues();

    constructor() {}

    enlargerOpen() {
        this.rotation = 0;
        this.zoom_scale = 1.0;
        this.open = true;
        // setTimeout(() => {
        //   this.image_element = document.getElementById("image-enlarger-image");
        //   if (this.image_element)
        //     this.image_element.style.transform = this.getTransformString(this.rotation, "", this.zoom_scale, "+",);
        // }, 1000);
    }

    enlargerCloser() {
        this.rotation = 0;
        this.zoom_scale = 1.0;
        this.open = false;
    }

    ngOnInit() {}

    round(a: number): number {
        return parseFloat((Math.round(a * 10) / 10).toFixed(1));
    }

    getTransformString(
        degree: number,
        degree_type: string,
        scale: number,
        scale_type: string
    ): string {
        if (degree_type == '+' && degree < this.operation_Values.MAXROTATE) {
            degree += 90;
        } else if (
            degree_type == '-' &&
            degree - 90 >= this.operation_Values.MINROTATE
        ) {
            degree -= 90;
        }
        if (scale_type == '+' && scale < this.operation_Values.MAXZOOM) {
            scale = this.round(scale + 0.1);
        } else if (
            scale_type == '-' &&
            this.round(scale - 0.1) >= this.operation_Values.MINZOOM
        ) {
            scale = this.round(scale - 0.1);
        }
        this.rotation = degree;
        this.zoom_scale = this.round(scale);

        let a: string =
            'rotate(' + this.rotation + 'deg) scale(' + this.zoom_scale + ')';
        return a;
    }

    operation(name: string) {
        this.image_element = document.getElementById('image-enlarger-image');
        switch (name) {
            case this.Operations_Label['ZOOMIN']:
                if (this.image_element)
                    this.image_element.style.transform =
                        this.getTransformString(
                            this.rotation,
                            '',
                            this.zoom_scale,
                            '+'
                        );

                break;
            case this.Operations_Label['ZOOMOUT']:
                if (this.image_element)
                    this.image_element.style.transform =
                        this.getTransformString(
                            this.rotation,
                            '',
                            this.zoom_scale,
                            '-'
                        );
                break;
            case this.Operations_Label['ROTATELEFT']:
                if (this.image_element)
                    this.image_element.style.transform =
                        this.getTransformString(
                            this.rotation,
                            '+',
                            this.zoom_scale,
                            ''
                        );

                break;
            case this.Operations_Label['ROTATERIGHT']:
                if (this.image_element)
                    this.image_element.style.transform =
                        this.getTransformString(
                            this.rotation,
                            '-',
                            this.zoom_scale,
                            ''
                        );

                break;

            default:
                break;
        }
    }
}
